module.exports = __webpack_public_path__ + "media/images/emblems/Busswil_bei_Melchnau-coat_of_arms-1aafbb5a359d5b4601f0106ce1352121.svg";